import { Message } from "element-ui";
import axios from "axios";
import { BASE_URL } from "@/config/baseURL";
import store from "../store/index";
import { expireSession } from "./authSession";
axios.defaults.baseURL = BASE_URL;

/* 请求响应超时时间 */
axios.defaults.timeout = 30000;

/* 设置post请求头 */
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    const token = store.state.token || localStorage.getItem('token');
    config.headers = config.headers || {};
    if (token) {
      config.headers.token = token;
    } else {
      delete config.headers.token;
    }
    // token && (config.headers.token = token);
    return config;
  },
  (error) => {
    return rejectRequest(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response.data);
    }
    const error = new Error("HTTP " + response.status);
    error.response = response;
    error.config = response.config;
    return rejectRequest(error);
  },
  (error) => {
    return rejectRequest(error);
  }
);

export function requestErrorMessage(error) {
  const en = localStorage.getItem("lang") === "en";
  const status = error.response && error.response.status;
  if (status === 401) return en ? "Please log in to continue." : "请登录后操作！";
  if (status === 429) return en ? "Too many requests. Please try again shortly." : "请求过于频繁，请稍后重试";
  if (status >= 500) return en ? "Service unavailable. Please try again later." : "服务暂时不可用，请稍后重试";
  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
    return en ? "Request timed out. Please try again." : "请求超时，请重试";
  }
  if (!error.response) return en ? "Network unavailable. Check your connection and retry." : "网络连接失败，请检查网络后重试";
  const data = error.response.data;
  return (data && typeof data.message === "string" && data.message.trim())
    || (en ? "Request failed. Please try again." : "请求失败，请重试");
}

function rejectRequest(error) {
  error.isRequestError = true;
  const expired = expireSession(error);
  const staleUnauthorized = error.response && error.response.status === 401
    && error.config && error.config.headers && error.config.headers.token && !expired;
  if (!staleUnauthorized && !axios.isCancel(error) && !(error.config && error.config.skipError)) {
    Message({ showClose: true, message: requestErrorMessage(error), type: "error", duration: 3000 });
  }
  return Promise.reject(error);
}

// UI boundaries may consume an already reported request failure, not coding errors.
export function handleRequestFailure(error) {
  if (!error || !error.isRequestError) throw error;
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, options = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
